module.exports = __webpack_public_path__ + "fonts/Beeline_Sans-Medium.ec8dd0b2.ttf";